module.exports = __webpack_public_path__ + "static/media/transparent-logo.5765f497.png";